:host,
:where(.ld-icon) {
  --ld-icon-secondary-col: var(--ld-col-wht);
  --ld-icon-size-sm: 1rem;
  --ld-icon-size-md: 1.25rem;
  --ld-icon-size-lg: 1.5rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: var(--ld-icon-size-md);
  height: var(--ld-icon-size-md);

  ::slotted(svg),
  :where(svg) {
    width: var(--ld-icon-size-md);
    height: var(--ld-icon-size-md);
    flex-shrink: 0;
  }
}

:host(.ld-icon--sm),
:where(.ld-icon--sm) {
  &,
  ::slotted(svg),
  :where(svg) {
    width: var(--ld-icon-size-sm);
    height: var(--ld-icon-size-sm);
  }
}
:host(.ld-icon--lg),
:where(.ld-icon--lg) {
  &,
  ::slotted(svg),
  :where(svg) {
    width: var(--ld-icon-size-lg);
    height: var(--ld-icon-size-lg);
  }
}
